import { render, staticRenderFns } from "./playVideoBig.vue?vue&type=template&id=058e218b&scoped=true&"
import script from "./playVideoBig.vue?vue&type=script&lang=js&"
export * from "./playVideoBig.vue?vue&type=script&lang=js&"
import style0 from "./playVideoBig.vue?vue&type=style&index=0&id=058e218b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e218b",
  null
  
)

export default component.exports